var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-tooltip', { attrs: { "effect": "dark", "placement": "top", "content": _vm.$t('workbench.resourceManagers.audioUploader.tips') } }, [_c('div', { staticClass: "aaset-dialog-trigger", on: { "click": _vm.handleClick } }, [_c('svg-icon', { attrs: { "size": 22, "icon-class": "assets" } })], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };